import React from "react";
import { Database, Cpu, Rocket } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Database,
    title: "Connect your knowledge.",
    body:
      "Upload docs, point to a help center URL, or sync with Notion and Drive. We embed, chunk and keep it fresh — automatically.",
  },
  {
    n: "02",
    icon: Cpu,
    title: "Compose an agent.",
    body:
      "Write a system prompt, wire up tools, pick a model. Test in the playground, version every change, ship when ready.",
  },
  {
    n: "03",
    icon: Rocket,
    title: "Deploy across every channel.",
    body:
      "Go live on WhatsApp, email, webchat and voice in minutes. Track resolution, CSAT and spend from one dashboard.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="howitworks-section"
      className="relative py-28 md:py-40 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="text-[11px] font-mono tracking-[0.2em] uppercase text-[#7C5CFF]">
              ── How it works
            </span>
          </div>
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-white">
            From docs to deployed
            <br />
            <span className="italic text-white/80">in a single afternoon.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/[0.06] border border-white/[0.06] rounded-2xl overflow-hidden">
          {steps.map((s, i) => (
            <div
              key={i}
              className="bg-[#0a0a10] p-8 md:p-10 relative"
              data-testid={`step-card-${i}`}
            >
              <div className="flex items-center justify-between mb-8">
                <span className="font-serif text-5xl text-white/20">{s.n}</span>
                <s.icon className="w-5 h-5 text-[#7C5CFF]" />
              </div>
              <h3 className="font-serif text-[28px] leading-[1.1] text-white mb-3">
                {s.title}
              </h3>
              <p className="text-white/55 text-[15px] leading-relaxed">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
